import { Component, OnInit } from '@angular/core';
import { tnp } from 'src/app/constant/auto/tnp.constant';

@Component({
  standalone: false,
  selector: 'app-tn-pcell',
  templateUrl: './tn-pcell.component.html',
  styleUrls: ['./tn-pcell.component.css']
})
export class TnPcellComponent implements OnInit {

  readonly tnpList = tnp
  constructor() { }

  ngOnInit() {
  }

}
